<div class="tw-min-w-[200px] xl:tw-min-w-[260px] tw-h-full">
  <mh-data-rate-widget
    [loading]="loading"
    [title]="'followup.summary.data-rate.average-rating.title' | translate"
    [tooltipTitle]="'followup.summary.data-rate.general_qualification.tooltip_general_qualification'"
    [totalPercentage]="averageRatingPercentage"
    [subTitlePercentage]="averageRatingScore"
    [qualification]="qualificationAverageRating"
    [maxValue]="100"
    [typeDescription]="'text'"
    [description]="'followup.summary.data-rate.average-rating.description' | translate"
    [textPrincipalButton]="'followup.summary.data-rate.average-rating.view_trend' | translate | uppercase"
    [heigth]="heigth"
    (onViewMore)="onViewMore()">
  </mh-data-rate-widget>
</div>
